/**
 * @generated SignedSource<<0bf2905a96b958d07579dfb9c540abba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type UpdateGeneralAssetModelInput = {
  generalAssetModelId: string;
  updateGeneralAssetModelData: UpdateGeneralAssetModelData;
  clientMutationId?: string | null;
};
export type UpdateGeneralAssetModelData = {
  name?: string | null;
  familyId?: string | null;
};
export type updatePageUpdateGeneralAssetModelMutation$variables = {
  input: UpdateGeneralAssetModelInput;
};
export type updatePageUpdateGeneralAssetModelMutationVariables = updatePageUpdateGeneralAssetModelMutation$variables;
export type updatePageUpdateGeneralAssetModelMutation$data = {
  readonly updateGeneralAssetModel: {
    readonly generalAssetModel: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
      readonly family: {
        readonly id: string;
        readonly name: string;
      };
      readonly manufacturer: {
        readonly id: string;
        readonly name: string;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type updatePageUpdateGeneralAssetModelMutationResponse = updatePageUpdateGeneralAssetModelMutation$data;
export type updatePageUpdateGeneralAssetModelMutation = {
  variables: updatePageUpdateGeneralAssetModelMutationVariables;
  response: updatePageUpdateGeneralAssetModelMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UserError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserFieldError",
      "kind": "LinkedField",
      "name": "fields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v2/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageUpdateGeneralAssetModelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGeneralAssetModelPayload",
        "kind": "LinkedField",
        "name": "updateGeneralAssetModel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralAssetModel",
            "kind": "LinkedField",
            "name": "generalAssetModel",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "family",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "manufacturer",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageUpdateGeneralAssetModelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGeneralAssetModelPayload",
        "kind": "LinkedField",
        "name": "updateGeneralAssetModel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralAssetModel",
            "kind": "LinkedField",
            "name": "generalAssetModel",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "family",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "manufacturer",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81bacf22942a98c66a4609204fc7d2f8",
    "id": null,
    "metadata": {},
    "name": "updatePageUpdateGeneralAssetModelMutation",
    "operationKind": "mutation",
    "text": "mutation updatePageUpdateGeneralAssetModelMutation(\n  $input: UpdateGeneralAssetModelInput!\n) {\n  updateGeneralAssetModel(input: $input) {\n    generalAssetModel {\n      id\n      createdAt\n      name\n      family {\n        __typename\n        id\n        name\n      }\n      manufacturer {\n        __typename\n        id\n        name\n      }\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "420a664ea5aa7f75be6823a85c52bb27";

export default node;
